import React, { useState } from 'react';
import { Grid, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import TabPanel from '../common/ui/TabPanel';
import { AllPasses } from './AllPasses';
import { AtRiskPasses } from './AtRiskPasses';
import { mb } from '../common/theme/mbTokens';

const PassesPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('at_risk') === '1' ? 1 : 0;
  const [value, setValue] = useState(initialTab);

  const isAtRiskTab = value === 1;

  return (
    <Grid
      container
      direction="column"
      flexWrap="nowrap"
      sx={{ flex: 1, minHeight: 0, overflowY: isAtRiskTab ? 'auto' : undefined }}>
      <Grid item sx={{ px: mb.layout.cardPadding, pt: mb.layout.cardPadding }}>
        <Tabs value={value} onChange={(_, v: number) => setValue(v)}>
          <Tab label={t('passes.tabs.all')} />
          <Tab label={t('passes.tabs.at_risk')} />
        </Tabs>
      </Grid>

      <Grid
        item
        sx={{
          ...(isAtRiskTab ? { flex: '1 0 auto' } : { flex: 1, minHeight: 0 }),
          display: 'flex',
          flexDirection: 'column',
        }}>
        <TabPanel value={value} index={0}>
          <AllPasses />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AtRiskPasses />
        </TabPanel>
      </Grid>
    </Grid>
  );
};

export default PassesPage;
